import { useUnsavedGuard } from '@/hooks/useUnsavedGuard';
import { useT } from '@/i18n';
import { Link as F7Link, NavRight } from 'framework7-react';

interface SettingsSaveNavProps {
  isDirty: boolean;
  saving?: boolean;
  disabled?: boolean;
  onSave: () => void;
}
export default function SettingsSaveNav({
  isDirty,
  saving = false,
  disabled = false,
  onSave,
}: SettingsSaveNavProps) {
  const t = useT();
  useUnsavedGuard(isDirty);
  const active = isDirty && !saving && !disabled;

  return (
    <NavRight>
      <F7Link
        className={`settings-save-link${active ? '' : ' settings-save-link--off'}`}
        onClick={active ? onSave : undefined}
      >
        {saving ? t.saving : t.saveShort}
      </F7Link>
    </NavRight>
  );
}
